import {NetworkService} from "./NetworkService";
import Swal from "sweetalert2";
import {NetworkRequest} from "./NetworkRequest";

class EntryDataServices {
  static fetchCities = async () => {
    return NetworkService.request({
      alias: NetworkRequest.FetchCities,
      url: 'dimensionamento/cities',
      method: 'GET',
    }).then((response) => response);
  };

  static fetchAttributes = async (step) => {
    return NetworkService.request({
      alias: NetworkRequest.FetchAttributes,
      url: 'dimensionamento/fields-to-fill',
      method: 'GET',
      params: {
        step: step
      }
    }).then((response) => response);
  };

  static fetchPreExistentData = async (step) => {
    return NetworkService.request({
      alias: NetworkRequest.FetchPreExistentData,
      url: 'dimensionamento/attributes',
      method: 'GET',
      params: {
        step: step
      }
    }).then((response) => response);
  }

  static postAttributes = async (step, json) => {
    NetworkService.request({
      alias: NetworkRequest.PostAttributes,
      url: 'dimensionamento/attributes/fill',
      params:{
        step: step
      },
      method: 'POST',
      data: json
    }).then((response) => {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Dados salvos com sucesso!",
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true
      }).then(() => {
        window.location.reload();
      });
      console.log(response);
    });
  }
}


export default EntryDataServices;